var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"matches"}},_vm._l((_vm.matches),function(round,index){return _c('div',[_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("translate")(round.fullname)))]),_vm._l((round.matches),function(match,index2){return _c('Match',{key:match.id,attrs:{"id":match.id}})})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }